import React, { useId } from "react";

// Ring gauge (BUILD_SPEC §4.3): SVG, track circle, value arc as stroke-dasharray
// on a linearGradient, rounded caps, starts at 12 o'clock clockwise, glow in the
// arc's dominant colour, centre big Space Grotesk number + small Inter label.
export default function RingGauge({
  size = 200,
  value = 0, // 0..100
  stops = ["var(--ac-cyan)", "var(--ac-indigo)", "var(--ac-indigo-hi)"],
  glow = "rgba(91,108,255,.55)",
  centerNumber,
  label = "% of expected",
  numberSize = 46,
}) {
  const id = useId().replace(/:/g, "");
  const stroke = size * 0.125;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  const dash = (pct / 100) * c;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}
         style={{ display: "block" }}>
      <defs>
        <linearGradient id={`g-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          {stops.map((s, i) => (
            <stop key={i} offset={`${(i / (stops.length - 1)) * 100}%`} stopColor={s} />
          ))}
        </linearGradient>
        <filter id={`f-${id}`} x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="6" floodColor={glow} />
        </filter>
      </defs>
      {/* track */}
      <circle cx={cx} cy={cx} r={r} fill="none"
              stroke="var(--ui-track)" strokeWidth={stroke} />
      {/* value arc — rotate -90deg to start at 12 o'clock, go clockwise */}
      <circle
        cx={cx} cy={cx} r={r} fill="none"
        stroke={`url(#g-${id})`} strokeWidth={stroke} strokeLinecap="round"
        strokeDasharray={`${dash} ${c - dash}`}
        transform={`rotate(-90 ${cx} ${cx})`}
        filter={`url(#f-${id})`}
      />
      <text x="50%" y="50%" textAnchor="middle"
            style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700,
              fontSize: numberSize, letterSpacing: "-1.8px", fill: "var(--ui-text-hi)" }}
            dy="0.02em">
        {centerNumber != null ? centerNumber : Math.round(pct)}
      </text>
      <text x="50%" y="50%" textAnchor="middle"
            style={{ fontFamily: "'Inter', sans-serif", fontSize: 12,
              fill: "var(--ui-text-lo)" }}
            dy={numberSize * 0.62}>
        {label}
      </text>
    </svg>
  );
}
